import { Checkbox, Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'

import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom'
import { OPCOES_AUTO_ANALISE, type OpcaoAutoAnalise } from '../../meta/autoAnalise'
import { ContainerAuto, FooterAuto } from './styled'

interface PropsEscolha {
    abrir: boolean
    selecionadas: OpcaoAutoAnalise[]
    aoSelecionar: (opcoes: OpcaoAutoAnalise[]) => void
    aoConfirmar: () => void
    aoCancelar: () => void
}

/**
 * Passo 1 do fluxo de micronutrientes: quais análises complementares gerar
 * automaticamente com os mesmos pontos.
 * Portado de `Components/googleMaps/index.tsx:325-350`.
 */
export const EscolherAutoAnalise: React.FC<PropsEscolha> = ({
    abrir,
    selecionadas,
    aoSelecionar,
    aoConfirmar,
    aoCancelar,
}) => {
    return (
        <Modal
            open={abrir}
            onCancel={aoCancelar}
            title='Deseja gerar as seguintes análises?'
            width={480}
            footer={false}
            destroyOnClose
            zIndex={10000}
        >
            <ContainerAuto>
                <p className='texto__auto'>
                    As análises marcadas serão criadas com os mesmos pontos que receberam
                    micronutrientes.
                </p>

                <Checkbox.Group
                    style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
                    value={selecionadas}
                    onChange={(valores) => aoSelecionar(valores as OpcaoAutoAnalise[])}
                    options={OPCOES_AUTO_ANALISE.map((item) => ({
                        label: item.rotulo,
                        value: item.valor,
                    }))}
                />

                <FooterAuto>
                    <ButtonCustom
                        onClick={aoCancelar}
                        type='secondary'
                        danger
                        icon={<FontAwesomeIcon icon={faXmark} />}
                    >
                        Cancelar
                    </ButtonCustom>
                    <ButtonCustom
                        onClick={aoConfirmar}
                        type='primary'
                        icon={<FontAwesomeIcon icon={faArrowRight} />}
                    >
                        Continuar
                    </ButtonCustom>
                </FooterAuto>
            </ContainerAuto>
        </Modal>
    )
}

interface PropsRestante {
    abrir: boolean
    /** `incluir` responde se o 00-20 Macro+S deve ser gerado com os pontos restantes. */
    aoResponder: (incluir: boolean) => void
}

/**
 * Passo 2: gerar também o 00-20 Macro+S com os pontos que NÃO receberam
 * micronutrientes. Portado de `googleMaps/index.tsx:352-365` (`macroRestante`).
 */
export const ConfirmarPontosRestantes: React.FC<PropsRestante> = ({ abrir, aoResponder }) => {
    return (
        <Modal
            open={abrir}
            onCancel={() => aoResponder(false)}
            title='Pontos restantes'
            width={520}
            footer={false}
            destroyOnClose
            zIndex={10000}
        >
            <ContainerAuto>
                <p className='texto__auto'>
                    Deseja gerar os pontos de <b>00 a 20 cm | Macro + S</b>, desconsiderando os
                    pontos com micronutrientes?
                </p>

                <FooterAuto>
                    <ButtonCustom
                        onClick={() => aoResponder(false)}
                        type='secondary'
                        danger
                        icon={<FontAwesomeIcon icon={faXmark} />}
                    >
                        Não
                    </ButtonCustom>
                    <ButtonCustom
                        onClick={() => aoResponder(true)}
                        type='primary'
                        icon={<FontAwesomeIcon icon={faCheck} />}
                    >
                        Sim
                    </ButtonCustom>
                </FooterAuto>
            </ContainerAuto>
        </Modal>
    )
}
